import { Tutorial } from '../tutorial.model';

/**
 * O tour da listagem de documentos administrativos.
 *
 * Os quatro alvos foram escolhidos LENDO a tela (`pages/list/list.component.html`
 * e `components/filters/filters.component.html`): cada `alvo` abaixo tem um
 * `data-tour` correspondente num template de produção, e o portão
 * `tutorial-alvos.pure.spec.ts` reprova a suíte se algum deixar de ter.
 *
 * A ordem é a de USO da tela: achar (busca), recortar (filtros), criar (o
 * botão) e, por último, ler o que a tabela avisa (a validade). "Adicionar
 * documento" depende de permissão — sem o elemento na tela, o motor pula o
 * passo sozinho.
 */
export const DOCUMENTOS_TOUR: Tutorial = {
  id: 'documentos',
  rota: '/painel/documentos-administrativos',
  passos: [
    {
      alvo: 'documentos.busca',
      titulo: 'Encontre o documento pelo nome',
      corpo: 'Digite parte do nome e a lista se recorta enquanto você escreve.',
      posicao: 'abaixo',
    },
    {
      alvo: 'documentos.filtros',
      titulo: 'Recorte por responsável, período e vigência',
      corpo:
        'Veja só os documentos de um cliente, fornecedor, funcionário ou estagiário; os cadastrados num ' +
        'período; os vigentes, os expirados ou os sem validade. A lista abre mostrando só os ativos.',
      posicao: 'abaixo',
    },
    {
      alvo: 'documentos.novo',
      titulo: 'Cadastre um documento novo',
      corpo:
        'Todo documento responde a alguém: escolha o tipo e a entidade, diga se ele expira e anexe os ' +
        'arquivos. Nome e responsável são obrigatórios.',
      posicao: 'abaixo',
    },
    {
      alvo: 'documentos.validade',
      titulo: 'A validade avisa quando venceu',
      corpo:
        'Documento com data de validade ganha o selo "Expirado" assim que ela passa. "Não expira" é o ' +
        'documento sem prazo.',
      posicao: 'abaixo',
    },
  ],
};
